import calender from "./calendar.svg";
import hourglass from "./hour-glass.svg";
import lawbalance from "./law-balance.svg";
import logo from "./logo.svg";
import person from "./person.svg";
import lawyer from "./lawyer.svg";
import lawhammer from "./law-hammer.svg";
import main_illustration from "./main_illustration.svg";
import main_illustration2 from "./main_illustration2.svg";

const svg = {
    calender,
    hourglass,
    lawbalance,
    lawhammer,
    logo,
    lawyer,
    person,
    main_illustration,
    main_illustration2
}

export default svg;